// extracted by mini-css-extract-plugin
export default {"card":"c-e_cY","card_styleDefault":"c-e_cZ","card_styleRed":"c-e_ea"};